import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { EnteAutocompleteItem } from 'cdc-conte-ui-kit';
import { SequStatoRichiestaEnum } from '../../../../../models/enums/codi-stato-richiesta.enum';
import { SelectOptionsInterface } from '../../../../../models/interfaces/documenti-adempimenti/carica-documento.interfaces';

export interface FiltriRichiesteVisibilityEntry {
  readonly name: string;
  readonly visible: boolean;
}

export type FiltriRichiesteSearchForm = FormGroup<{
  search: FormControl<string | null>;
}>;

export type FiltriRichiesteFiltersForm = FormGroup<{
  esercizio: FormControl<SelectOptionsInterface | null>;
  fase: FormControl<SelectOptionsInterface | null>;
  tipoEnte: FormControl<{ id: number; text: string; disabled: boolean }[] | null>;
  regione: FormControl<SelectOptionsInterface | string | null>;
  provinciaCittaMetropolitana: FormControl<SelectOptionsInterface | string | null>;
  denominazioneEnte: FormControl<EnteAutocompleteItem | null>;
  adempimentoNormativo: FormControl<SelectOptionsInterface | null>;
  tipoDocumento: FormControl<SelectOptionsInterface | null>;
  statoRichiesta: FormControl<SelectOptionsInterface | number | null>;
  dataRichiestaMin: FormControl<string | null>;
  dataRichiestaMax: FormControl<string | null>;
}>;

  export const DEFAULT_STATO_RICHIESTA: SelectOptionsInterface = {
  desc: 'Non evasa',
  id: SequStatoRichiestaEnum.NON_EVASA,
  meta: {},
};

export const createSearchForm = (): FiltriRichiesteSearchForm =>
  new FormGroup({
    search: new FormControl(''),
  });

export const createFiltersForm = (): FiltriRichiesteFiltersForm =>
  new FormGroup({
    esercizio: new FormControl<SelectOptionsInterface | null>(null),
    fase: new FormControl<SelectOptionsInterface | null>(null),
    tipoEnte: new FormControl<{ id: number; text: string; disabled: boolean }[]>([]),
    regione: new FormControl<SelectOptionsInterface | string | null>(null),
    provinciaCittaMetropolitana: new FormControl<SelectOptionsInterface | string | null>(null),
    denominazioneEnte: new FormControl<EnteAutocompleteItem | null>(null),
    adempimentoNormativo: new FormControl<SelectOptionsInterface | null>(null),
    tipoDocumento: new FormControl<SelectOptionsInterface | null>(null),
    statoRichiesta: new FormControl<SelectOptionsInterface | number | null>(DEFAULT_STATO_RICHIESTA.id),
    dataRichiestaMin: new FormControl<string | null>(null),
    dataRichiestaMax: new FormControl<string | null>(null),
  });

/**
 * Adds or removes filter controls based on role/visibility flags so the form
 * only contains fields that are currently shown in the template.
 */
export const updateFormFilters = (
  formFilters: FormGroup,
  visibilityMap: readonly FiltriRichiesteVisibilityEntry[],
): void => {
  const dynamicForm = formFilters as unknown as FormGroup<Record<string, AbstractControl>>;

  visibilityMap.forEach(({ name, visible }) => {
    if (visible && !dynamicForm.contains(name)) {
      dynamicForm.addControl(name, new FormControl(null));
    }

    if (!visible && dynamicForm.contains(name)) {
      dynamicForm.removeControl(name);
    }
  });

  formFilters.updateValueAndValidity();
};
